import { render, staticRenderFns } from "./review-titan.vue?vue&type=template&id=450b0d24&scoped=true&"
import script from "./review-titan.vue?vue&type=script&lang=js&"
export * from "./review-titan.vue?vue&type=script&lang=js&"
import style0 from "./review-titan.vue?vue&type=style&index=0&id=450b0d24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "450b0d24",
  null
  
)

export default component.exports